interface BetaBadgeProps {
  className?: string;
}

export const BetaBadge: React.FC<BetaBadgeProps> = ({ className = "" }) => {
  return (
    <div className={`flex items-center px-2 py-1 text-xs font-medium rounded-md bg-[#FCE9F2] text-[#D45087] ${className}`}>
      <span>Beta</span>
    </div>
  );
};
